import React, { useState } from 'react';
import { collection, getDocs, addDoc, doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase/firebaseConfig';
import { useAuth } from '../context/AuthContext';

const SubmitClaim = () => {
  const { currentUser } = useAuth();
  const [itemName, setItemName] = useState('');
  const [itemDescription, setItemDescription] = useState('');
  const [yourName, setYourName] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!currentUser) {
      alert('Please log in to submit a claim.');
      return;
    }

    const newClaim = {
      itemName,
      claimedDescription: itemDescription,
      yourName,
      email,
      userId: currentUser.uid,
      matched: false,
      status: 'claim requested',
      timestamp: new Date(),
    };

    try {
      // Step 1: Add claim to Firestore
      const claimRef = await addDoc(collection(db, 'claims'), newClaim);

      // Step 2: Try to match with lost items
      const lostItemsSnap = await getDocs(collection(db, 'lostItems'));
      const lostItems = lostItemsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      const claimText = `${itemName} ${itemDescription}`.toLowerCase();

      const match = lostItems.find(lost => {
        const lostText = `${lost.itemName} ${lost.description}`.toLowerCase();
        return claimText.includes(lost.itemName.toLowerCase()) || lostText.includes(itemName.toLowerCase());
      });

      if (match) {
        await updateDoc(doc(db, 'claims', claimRef.id), {
          matched: true,
          itemId: match.id
        });
      }

      alert('✅ Claim submitted successfully!');
      setItemName('');
      setItemDescription('');
      setYourName('');
      setEmail('');
    } catch (error) {
      console.error('Error submitting claim:', error);
      alert('❌ Error submitting claim.');
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Submit a Claim</h2>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1rem', maxWidth: '400px' }}>
        <input
          type="text"
          value={yourName}
          onChange={(e) => setYourName(e.target.value)}
          placeholder="Your Full Name"
          required
        />
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Your Email Address"
          required
        />
        <input
          type="text"
          value={itemName}
          onChange={(e) => setItemName(e.target.value)}
          placeholder="Item Name"
          required
        />
        <textarea
          value={itemDescription}
          onChange={(e) => setItemDescription(e.target.value)}
          placeholder="Describe the item in detail"
          required
          rows={4}
        ></textarea>
        <button type="submit" style={{ padding: '0.5rem 1rem', backgroundColor: '#1B3B6F', color: 'white', border: 'none', borderRadius: '5px' }}>
          Submit Claim
        </button>
      </form>
    </div>
  );
};

export default SubmitClaim;
